import React from "react"
import { graphql } from "gatsby"
import Header from "../header"
import { Button, Col, Row } from "react-bootstrap"

export default function ContributionTemplate(data) {
  const pageData = data.data.contributionsJson
  return (
    <>
      <Header />
      <Row>
        <Col xs={12} md={{span: 8, offset: 2}}>
          <h1>{pageData.title}</h1>
          <p><strong>Author: </strong>{pageData.author_name}</p>
          <p><strong>Date Published: </strong>{pageData.date_published}</p>
          <p><strong>Original language: </strong>{pageData.original_language}</p>
          <p><strong>Other languages: </strong>{pageData.other_languages}</p>
          <p><strong>Non latin titles: </strong>{pageData.non_lating_titles}</p>
          <p><strong>Descriptors: </strong>{pageData.descriptors}</p>
          <p><strong>Identifiers: </strong>{pageData.identifiers}</p>
          <p><strong>Item available at: </strong>{pageData.item_available_at}</p>
          <p><strong>Nature of contents: </strong>{pageData.nature_of_contents}</p>
          <p><strong>Imprint: </strong>{pageData.imprint}</p>
          <Button href={pageData.pdf_url}>View Pdf</Button>
        </Col>
      </Row>
    </>
  )
}

export const query = graphql`
  query($id: String!) {
    contributionsJson(id: {eq: $id}) {
      title,
      author_name,
      date_published,
      original_language,
      other_languages,
      other_language_titles,
      non_latin_titles,
      descriptors,
      identifiers,
      item_available_at,
      nature_of_contents,
      imprint,
      pdf_url
    }  
  }
`
